module.exports = __webpack_public_path__ + "static/media/robertMaurer.234bd2f8.jpg";